import EmptyList from 'components/EmptyList/EmptyList';
import Loader from 'components/Loader/Loader';
import Panel from 'components/Panel/Panel';
import Separator from 'components/Separator/Separator';

import CompanyUserCard from './components/CompanyUserCard/CompanyUserCard';
import CompanyUsersHeading from './components/CompanyUsersHeading/CompanyUsersHeading';

import type ICompanyUsersView from './interfaces/ICompanyUsersView';

import styles from './scss/CompanyUsersView.module.scss';

function CompanyUsersView({
  users, control, onSearch, isPageLoading,
}: ICompanyUsersView) {
  return (
    <Panel className={styles.root}>
      <CompanyUsersHeading
        control={control}
        onSearch={onSearch}
      />
      {users.length || isPageLoading ? (
        <ul className={styles.list}>
          <Loader isPageLoading={isPageLoading} isFullLoader={false} />
          {users.map((user, index) => (
            <li key={user.id}>
              <CompanyUserCard user={user} />
              {users.length - 1 !== index ? <Separator /> : null}
            </li>
          ))}
        </ul>
      ) : !isPageLoading && (
        <EmptyList />
      )}
    </Panel>
  );
}

export default CompanyUsersView;
